//import { getShowWellnessLink } from './Utils.js';

export function getInBox(props) {
    const { hasMyChart, epicEHRDown, bundle, isMedicalAdvice, bffDashboardData, currentUser, enableCareCompanion, thriveData, currentPharmacyUser, isMyChartInActive } = props;
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const showCareCoach = getShowCareCoach(bffDashboardData, currentUser, enableCareCompanion);
    const enableThrive365Tile = window.serverData.data.enableThrive365Tile;
    const surveyStatusEnabled = (thriveData && thriveData.surveyStatus) ? (thriveData.surveyStatus && thriveData.surveyStatus.toLowerCase() !== "not_enrolled") : false;
    const showWellnessLink = getShowWellnessLink(props);

    return {
        icon: 'icon-messages',
        show: notPharmacyProxy && hasMyChart,
        disabled: epicEHRDown || isMyChartInActive,
        navHead: {
            label: 'Communications',
            url: null
        },
        navItems: [
            {
                label: 'All Messages',
                show: notPharmacyProxy && hasMyChart,
                url: '/messagesAll',
                subMenuItems: null
            },
            {
                label: 'Send a Message',
                show: notPharmacyProxy && hasMyChart && isMedicalAdvice,
                url: '/messagesSend',
                subMenuItems: null
            },
            {
                label: 'Letters',
                show: notPharmacyProxy && hasMyChart,
                url: '/letters',
                subMenuItems: null
            },
            {
                label: enableCareCompanion ? 'Care Companion' : 'Care Coach',
                show: notPharmacyProxy && hasMyChart && showCareCoach,
                url: enableCareCompanion ? '/carecompanion' : '/carecoachall',
                altUrls: enableCareCompanion ? ['/carecoachmessage', '/carecoachall'] : ['/carecoachmessage', '/carecompanion'],
                subMenuItems: null
            }
        ]
    };
}


const getShowCareCoach = ( bffDashboardData, currentUser, enableCareCompanion) => {
    
    let showCareCoach = false

    if (enableCareCompanion) {
        showCareCoach = true;
    //} else {
    //    if (currentUser && currentUser.epi && bffDashboardData && bffDashboardData.data && bffDashboardData.data.dcjStatus && bffDashboardData.data.dcjStatus.dcjList) {
    //        const dcjList = bffDashboardData.data.dcjStatus.dcjList;
    //        for (let i = 0; i < dcjList.length; i++) {
    //            let dcjitem = dcjList[i];
    //            if (dcjitem && dcjitem.patient_id && dcjitem.patient_id === currentUser.epi) {
    //                showCareCoach = true;
    //                break;
    //            }
    //        }
    //    }
    }

    return showCareCoach;
}

const getShowWellnessLink = (props) => {
    return props && props.enableCareCompanion;
    //const { bffDashboardData, currentUser } = props;
    //let showWellnessLink = false;
    //if (currentUser && currentUser.epi && bffDashboardData && bffDashboardData.data && bffDashboardData.data.dcjStatus && bffDashboardData.data.dcjStatus.wellnessDCJList && bffDashboardData.data.dcjStatus.wellnessDCJList.length) {
    //    const dcjList = bffDashboardData.data.dcjStatus.wellnessDCJList;
    //    for (let i = 0; i < dcjList.length; i++) {
    //        let dcjitem = dcjList[i];
    //        if (dcjitem && dcjitem.patient_id && dcjitem.patient_id === currentUser.epi) {
    //            showWellnessLink = true;
    //            break;
    //        }
    //    }
    //}
    //return showWellnessLink;
}